module.exports = __webpack_public_path__ + "img/download.b04393e7.png";